<div class="container">
  <mat-card class="example-card">
    <mat-card-header>
      <mat-card-title>Download App</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <img
        class="playstore-icon"
        src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Google_Play_Arrow_logo.svg/512px-Google_Play_Arrow_logo.svg.png"
        alt="Play Store Icon"
      />
      <button mat-raised-button class="mat-button">Get it on Play Store</button>
    </mat-card-content>
  </mat-card>
</div>
